module.exports = __webpack_public_path__ + "img/message-alert-square.35dcbf6b.svg";